import { c as create_ssr_component, s as subscribe, v as validate_component, a as add_attribute } from "../../chunks/ssr.js";
import { c as currentIndex, a as cartIsOpen, L as Loader, S as SlideShowControls, N as NavBar, C as Content, b as ContextMenu, d as Cart, T as TextCard, P as Properties, A as AddToCart, e as Logo, f as ThankYou } from "../../chunks/Content.js";
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let currentBook;
  let $currentIndex, $$unsubscribe_currentIndex;
  let $cartIsOpen, $$unsubscribe_cartIsOpen;
  $$unsubscribe_currentIndex = subscribe(currentIndex, (value) => $currentIndex = value);
  $$unsubscribe_cartIsOpen = subscribe(cartIsOpen, (value) => $cartIsOpen = value);
  let { data } = $$props;
  let books;
  let quantity = 1;
  let activePanel = "3D";
  let showThankYouModal = false;
  let rightPanel;
  let rightPanelMiddle = 0;
  let progress = 0;
  function closeThankYouModal() {
    showThankYouModal = false;
  }
  if ($$props.data === void 0 && $$bindings.data && data !== void 0) $$bindings.data(data);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    books = data.serif || [];
    currentBook = books[$currentIndex] || {};
    {
      {
        if (data.stripeSuccess) {
          showThankYouModal = true;
        }
      }
    }
    $$rendered = `${`${validate_component(Loader, "Loader").$$render($$result, { progress }, {}, {})}`} ${validate_component(SlideShowControls, "SlideShowControls").$$render($$result, { books }, {}, {})} <div class="relative flex flex-col lg:flex-row h-full mb-4"><div class="content w-full lg:w-3/4 h-[30vh] ml-1 sm:h-[40vh] lg:h-full z-20 relative rounded-lg order-1 lg:order-2 shadow-lg"${add_attribute("this", rightPanel, 0)}>${validate_component(NavBar, "NavBar").$$render($$result, { books }, {}, {})} ${validate_component(Content, "Content").$$render($$result, { currentBook, books, activePanel }, {}, {})} <div class="items-center justify-center w-full mt-2">${validate_component(ContextMenu, "ContextMenu").$$render(
      $$result,
      { rightPanelMiddle, activePanel },
      {
        activePanel: ($$value) => {
          activePanel = $$value;
          $$settled = false;
        }
      },
      {}
    )}</div></div> <div class="info lg:relative flex flex-col w-full lg:w-1/4 z-40 mt-4 lg:mt-0 order-2 lg:order-1"><div class="flex flex-col h-full">${$cartIsOpen ? `${validate_component(Cart, "Cart").$$render($$result, {}, {}, {})}` : `<div class="flex flex-col relative h-full w-full">${validate_component(TextCard, "TextCard").$$render($$result, { currentBook }, {}, {})} <div class="controls flex-shrink-0 h-auto mt-1">${validate_component(Properties, "Properties").$$render($$result, { currentBook }, {}, {})} ${validate_component(AddToCart, "AddToCart").$$render(
      $$result,
      { currentBook, quantity },
      {
        quantity: ($$value) => {
          quantity = $$value;
          $$settled = false;
        }
      },
      {}
    )}</div></div>`}</div></div></div> ${validate_component(Logo, "Logo").$$render($$result, { activePanel }, {}, {})} ${validate_component(ThankYou, "ThankYou").$$render(
      $$result,
      {
        show: showThankYouModal,
        onClose: closeThankYouModal
      },
      {},
      {}
    )}`;
  } while (!$$settled);
  $$unsubscribe_currentIndex();
  $$unsubscribe_cartIsOpen();
  return $$rendered;
});
export {
  Page as default
};
